<template>
  <div>
    <div class="title">
      <tax-source-info :info="taxInfo" />
      <settlement :ref-id="id" :is-audit="true" />
    </div>
  </div>
</template>

<script setup lang="ts">
import TaxSourceInfo from './tax-source-info.vue';
import { computed, ref } from 'vue';
import Settlement from '../../../crowd-source/commission-sharing-task/settlement.vue';
import { useRoute } from 'vue-router';
import { IApproveTaskDetail } from '@core/main/types/system/approval';
import { ElMessage } from 'element-plus';
import { queryApproveTaskDetail } from '@core/main/api';

const taxInfo = ref({} as IApproveTaskDetail);

const route = useRoute();
const id = computed(() => route.query && route.query.refId ? Number(route.query.refId) : undefined);
const type = computed(() => route.query && route.query.type ? Number(route.query.type) : undefined);

async function getTaskDetail() {
  try {
    taxInfo.value = await queryApproveTaskDetail({
      type: type.value,
      refId: id.value,
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

getTaskDetail();

defineOptions({ name: 'CreateDistributionTask' });

</script>